import { Link } from "react-router-dom";
import { Check, ChevronDown } from "lucide-react";
import { Amount } from "@/components/spt/SptTabs";

const pickAmounts = (id, d) => {
  if (!d) return [];
  if (id === "l1a" || id === "l1b" || id === "l2b") return [["Total", d.total]];
  if (id === "l1d") return [["Penghasilan bruto", d.bruto], ["Penghasilan neto", d.neto], ["PPh 21 dipotong", d.pph21_dipotong]];
  if (id === "l2a") return [["Penghasilan bruto", d.total_bruto], ["PPh final", d.total_pph]];
  if (id === "l3b_a") return [["Omzet setahun", d.total_omzet], ["PPh final", d.total_pph_final]];
  if (id === "l3a2") return [["Peredaran usaha", d.peredaran_usaha], ["Neto fiskal", d.laba_neto_fiskal]];
  return [];
};

export function GuideStep({ no, step, tahun, data, done, open, onToggle, onDone }) {
  const amounts = pickAmounts(step.data, data?.[step.data]);
  return (
    <li className={`rounded-lg border transition-colors ${done ? "border-emerald-200 bg-emerald-50/40" : "border-slate-200 bg-white"}`} data-testid={`guide-step-${step.id}`}>
      <button type="button" onClick={onToggle} className="w-full flex items-center gap-3 p-4 text-left" data-testid={`guide-toggle-${step.id}`}>
        <span className={`h-8 w-8 shrink-0 rounded-full flex items-center justify-center text-sm font-semibold ${done ? "bg-emerald-600 text-white" : "bg-[#166db4]/10 text-[#166db4]"}`}>
          {done ? <Check size={16}/> : no}
        </span>
        <span className="flex-1 min-w-0">
          <span className="flex items-center gap-2 flex-wrap">
            {step.tab && <span className="text-[10px] font-bold tracking-wide px-1.5 py-0.5 rounded bg-amber-300 text-slate-900">TAB {step.tab}</span>}
            <span className="font-semibold text-slate-800">{step.title}</span>
          </span>
          <span className="block text-[13px] text-slate-500 mt-0.5">{step.simple}</span>
        </span>
        <ChevronDown size={18} className={`text-slate-400 transition-transform ${open ? "rotate-180" : ""}`}/>
      </button>
      {open && (
        <div className="px-4 pb-4 pl-[60px] space-y-3">
          <ul className="list-disc pl-4 space-y-1.5 text-sm text-slate-700">
            {step.points.map((p) => <li key={p}>{p.replace("{tahun}", tahun)}</li>)}
          </ul>
          {amounts.length > 0 && (
            <div className="rounded-md bg-slate-50 border border-slate-200 p-3 space-y-2" data-testid={`guide-amounts-${step.id}`}>
              <div className="text-[11px] uppercase tracking-wide text-slate-500">Angka Anda (salin ke Coretax)</div>
              {amounts.map(([l, v]) => <div key={l} className="flex items-center justify-between gap-3 text-sm"><span>{l}</span><Amount v={v} label={l} testid={`guide-copy-${step.id}-${l.replace(/\s+/g, "-").toLowerCase()}`}/></div>)}
            </div>
          )}
          <div className="flex flex-wrap items-center gap-2">
            {(step.links || []).map(([to, l]) => <Link key={to} to={to} className="text-[13px] font-medium text-[#166db4] hover:underline">{l} →</Link>)}
            {step.data && <Link to="/pribadi/spt-coretax" className="text-[13px] font-medium text-[#166db4] hover:underline">Buka Asisten SPT Coretax →</Link>}
            <button type="button" onClick={onDone} data-testid={`guide-done-${step.id}`}
              className={`ml-auto rounded-full px-3 py-1.5 text-[12px] font-semibold transition-colors ${done ? "bg-emerald-100 text-emerald-700" : "bg-[#166db4] text-white hover:bg-[#125a95]"}`}>
              {done ? "Sudah selesai ✓" : "Tandai selesai"}
            </button>
          </div>
        </div>
      )}
    </li>
  );
}
